import { sectionContainerAtom } from '@ingenico/react-section-utils';
import type { LogicalDeviceScreenSharePageProps } from '@ingenico/type-mfe-contracts/domains';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import type { ReactElement } from 'react';
import { memo, useMemo } from 'react';
import { deviceManagementContainer } from '../../container.const';
import { LogicalDeviceScreenSharePage } from '../../pages/logical-device-screen-share-page/LogicalDeviceScreenSharePage.ctrl';

function ExposedLogicalDeviceScreenSharePageCpnt(props: LogicalDeviceScreenSharePageProps): ReactElement {
  // Pre-initialize the section container on a fresh store before any child renders.
  // @ingenico/react-section-utils reads sectionContainerAtom synchronously during render and
  // throws if it is null, so the value must be set before the Provider mounts its children.
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  return (
    <Provider store={store}>
      <LogicalDeviceScreenSharePage {...props} />
    </Provider>
  );
}

export const ExposedLogicalDeviceScreenSharePage = memo(ExposedLogicalDeviceScreenSharePageCpnt, deepEqual);
